<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path fill-rule="evenodd" d="M6.3 7.65c0-1.494 1.206-2.7 2.7-2.7 1.494 0 2.7 1.206 2.7 2.7 0 1.494-1.206 2.7-2.7 2.7a2.696 2.696 0 0 1-2.7-2.7Zm1.35 0C7.65 8.397 8.253 9 9 9c.747 0 1.35-.603 1.35-1.35 0-.747-.603-1.35-1.35-1.35-.747 0-1.35.603-1.35 1.35Z" clip-rule="evenodd"/>
    <path fill-rule="evenodd" d="M1.8 9c0-3.978 3.222-7.2 7.2-7.2s7.2 3.222 7.2 7.2-3.222 7.2-7.2 7.2A7.198 7.198 0 0 1 1.8 9Zm3.636 4.626A5.807 5.807 0 0 0 9 14.85a5.807 5.807 0 0 0 3.564-1.224 6.703 6.703 0 0 0-7.128 0ZM9 11.25c1.692 0 3.267.513 4.563 1.404A5.823 5.823 0 0 0 14.85 9 5.861 5.861 0 0 0 9 3.15 5.861 5.861 0 0 0 3.15 9c0 1.386.486 2.655 1.287 3.654A8.117 8.117 0 0 1 9 11.25Z" clip-rule="evenodd"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
